const getInputSizeClasses = (size) =>
  ({
    small: 'px-3 py-2 text-xs',
    medium: 'px-5 py-2 text-sm',
    large: 'px-5 py-4 leading-5'
  })[size];

export default getInputSizeClasses;
